var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ( _vm.count && _vm.isShowCounter)?_c('span',{staticClass:"additional-images-count"},[_vm._v(" + "+_vm._s(_vm.count))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }